import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SelectDomainComponent } from 'app/components/select-domain/select-domain/select-domain.component';
import { Domain } from 'app/models/domain.model';
import { Travel } from 'app/models/travel.model';
import { User } from 'app/models/user.model';
import { DomainsService } from 'app/services/domains/domains.service';
import { TravelService } from 'app/services/travel/travel.service';
import { TravelsComponent } from '../travels/travels.component';
import { TodayTravelsComponent } from './today-travels/today-travels.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {

  allTravels: Travel[] = [];
  activeTravels: Travel[] = [
    {

      initTime: '08:00 am',
      status: 'on time',
      route: {
        description: 'Viaje a Las Terrenas',
      }
    },
    {
      initTime: '08:00 am',
      status: 'on time',
      route: {
        description: 'Viaje a La Romana',
      }
    },
    {
      initTime: '08:00 am',
      status: 'late',
      route: {
        description: 'UNPHU - Playa',
      }
    }
  ]

  upcomingTravels: Travel[] = [
    {
      initTime: '09:00 am',
      status: 'on time',
      route: {
        description: 'Prolongacion 27',
      }
    },
    {
      initTime: '10:00 am',
      status: 'on time',
      route: {
        description: 'UNPHU - Playa',
      }
    },
    {
      initTime: '11:00 am',
      status: 'late',
      route: {
        description: 'UNPHU - Rio',
      }
    }
  ];

  completedTravels: Travel[]= [
    {
      initTime: '09:00 am',
      status: 'on time',
      route: {
        description: 'Prolongacion 27',
      }
    },
    {
      initTime: '10:00 am',
      status: 'on time',
      route: {
        description: 'UNPHU - Playa',
      }
    },
    {
      initTime: '11:00 am',
      status: 'late',
      route: {
        description: 'UNPHU - Rio',
      }
    }
  ]

  activeTravelDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) activeTravelPaginator: MatPaginator;
  activeTravelDisplayedColumn: string[] = ['description', 'initTime', 'status'];

  upcomingTravelDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) upcomingTravelPaginator: MatPaginator;
  upcomingTravelDisplayedColumn: string[] = ['description', 'initTime', 'status'];

  completedTravelDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) completedTravelPaginator: MatPaginator;
  completedTravelDisplayedColumn: string[] = ['description', 'initTime', 'status'];

  domains: Domain[];

  constructor(
    private dialog: MatDialog,
    private domainService: DomainsService,
    private router: Router,
    private travelService: TravelService
  ) { }

  ngOnInit(): void {
    this.domainService.getDomains().subscribe(result => {
      this.domains = result;
      console.log('domains loaded!');
    });
  }

  async ngAfterViewInit() {
    await this.getTravelsByEnterprise();
  }

  createTravel(){
    const dialogRef = this.dialog.open(SelectDomainComponent, {
      data: {
        domains: this.domains
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('dialog closed', result);
      this.router.navigate([`dashboard/domains/${result.selectedDomain}/route-detail/`], {state: {isRecurrent: false}});
    });
  }

  async getTravelsByEnterprise(){
    let enterprise: User = JSON.parse(sessionStorage.getItem('loggedUser'));
    this.allTravels = await this.travelService.getTravelsByEnterprise(enterprise.databaseId);
    this.sortTravels(this.allTravels);
  }

  sortTravels(travels: Travel[]){
    this.completedTravels = travels.filter(x => x.status == 'completed');
    this.activeTravels = travels.filter(x => x.status == 'started');
    this.upcomingTravels = travels.filter(x => x.status == 'not started');
    this.activeTravelDataSource = new MatTableDataSource<any>(this.activeTravels);
    this.activeTravelDataSource.paginator = this.activeTravelPaginator
    this.upcomingTravelDataSource = new MatTableDataSource<any>(this.upcomingTravels);
    this.upcomingTravelDataSource.paginator = this.upcomingTravelPaginator;
    this.completedTravelDataSource = new MatTableDataSource<any>(this.completedTravels);
    this.completedTravelDataSource.paginator = this.completedTravelPaginator;
    console.log('viajes:', this.upcomingTravels);
    // this.activeTravelDataSource.paginator = this.activePaginator;
  }

  private async viewTravel(travel: Travel){
    console.log('watch live travel', travel);
    let liveTravel;
    try {
      const dialogRef = this.dialog.open(TravelsComponent, {
        data: {
          travel: travel,
          liveTravel: true
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('travel dialog closed');
      })
    } catch (error) {
      console.error('error on load live travel info');
    }
    
  }

  private async openTodayTravels(){
    // window.print();
    // const dialogRef = await this.dialog.open(TodayTravelsComponent, {
    //   width: '1900px',
    //   height: '1700px',
    //   data: {
    //     allTravels: this.allTravels
    //   }
    // });
  }

}
